import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseCompanies } from "../incadea-interfaces/responses/ResponseCompanies.interface";
import { RespDeptMakes } from "../incadea-interfaces/responses/ResponseDeptMakes.interface";
import { incadeaEnvironment } from "src/environments/environment";
@Injectable({
    providedIn: 'root',
  })
export class GetMakesService {

  
    constructor(private http: HttpClient,
       ) { 

        }
    public getMakes(token:string,CompanyId:string,backEndCode:string) {
      
        // Define el encabezado de la solicitud
        const headers = new HttpHeaders()
        .set('Accept-Language', 'en-US,en;q=0.9')
        .set('Authorization', `Bearer ${token}`) 
        .set('backend-code', `${backEndCode}`);
      
        // Realiza la solicitud POST
       return this.http.get<RespDeptMakes[]>(`${incadeaEnvironment.companies}/${CompanyId}/makes`, { headers })
      }
    }
  